import { HttpContextToken } from '@angular/common/http';

export const IS_CALENSO_AUTH_REQUIRED = new HttpContextToken<boolean>(() => false);

// Marks requests whose 404 is an EXPECTED "resource not configured" outcome (e.g. a widget
// without an active CSS overwrite) — the interceptor skips the error log for those, so every
// widget load doesn't spam the console with an HttpErrorResponse that callers ignore anyway.
export const IS_EXPECTED_ABSENCE_404 = new HttpContextToken<boolean>(() => false);
